<template>
  <!-- person -->
  <div class="formGroup isRequired mt15 notranslate">
    <label class="label toCapitalize">{{locale.reservation_person}}</label>
    <select class="input" v-model="person" @change="selectPerson">
      <option value="" disabled>{{locale.select_person}}</option>
      <option
        v-for="p in 10"
        :key="p"
        :value="p"
        :disabled="userLimitedInfo && userLimitedInfo.person && userLimitedInfo.person < p">{{p}}</option>
      <!-- <option value="input">{{locale.direct_input}}</option> -->
    </select>
    <div v-if="person === 'input'" class="inputWithBtn mt5">
      <input type="text" class="input" v-model="personInput" @change="updatePerson">
    </div>
  </div>
  <!-- //person -->
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormPerson',
  props: [
    'lang',
    'ln',
    'locale',
    'info',
    'roomKey',
    'rid',
    'reservePerson',
    'isPublic',
    'userLimitedInfo'
  ],
  watch: {
    reservePerson (person) {
      if (!person) {
        this.person = ''
      }
    }
  },
  data () {
    let person = (this.userLimitedInfo && this.userLimitedInfo.person) || ''
    return {
      person,
      personInput: ''
    }
  },
  methods: {
    updatePerson () {
      const person = regExp.numberOnly(this.personInput) || ''
      this.personInput = person
      if (this.person === 'input') {
        this.selectPerson()
      }
    },
    selectPerson () {
      this.$emit('setPerson', this.person)
    }
  }
}
</script>
